import type {
  ExpenseCreatePaymentIntent,
  ExpenseSettleMethod,
} from '../domain/expenseTypes';

// Los tipos viven en domain/expenseTypes — este módulo solo tiene la capa UI
// (labels y defaults de formularios). Se re-exportan para compatibilidad.
export type { ExpenseCreatePaymentIntent, ExpenseSettleMethod };

export const EXPENSE_SETTLE_METHODS: Array<{ id: ExpenseSettleMethod; label: string }> = [
  { id: 'cash_drawer', label: 'Efectivo de la caja — ahora' },
  { id: 'transfer', label: 'Transferencia' },
  { id: 'card', label: 'Tarjeta' },
  { id: 'other', label: 'Ya pagado / otro' },
];

export const EXPENSE_CREATE_PAYMENT_INTENTS: Array<{ id: ExpenseCreatePaymentIntent; label: string }> = [
  { id: 'unpaid', label: 'Pendiente de pago' },
  { id: 'pay_now', label: 'Pagado ahora' },
];

export function defaultSettleMethodForSession(activeCashSessionId: string | null): ExpenseSettleMethod {
  return activeCashSessionId ? 'cash_drawer' : 'transfer';
}
